<template>

  <div>
    <h1>TEST</h1>
    <form-button @click="showCrudList = true">show</form-button>
    <custom-crud-list v-bind="listConfiguration" >
      <template #cell-entryValue="{ item }" >
        <div v-if="item?.entryValue"
             v-tooltip="{
              content: `${getEntryValueAsString(item?.entryValue)}`,
              translate: false,
            }"
             class="cursor-pointer text-overflow-ellipsis max-width-300">
          <span>{{ item?.entryValue }}</span>
        </div>
        <div v-else
             v-tooltip="{
              content: `${getEntryValueAsString(item?.entryValue)}`,
              translate: false,
            }"
             class="cursor-pointer text-overflow-ellipsis max-width-300">
          <span>{{ item?.entryValue }}</span>
        </div>

      </template>
    </custom-crud-list>
  </div>


</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import CustomCrudList from "@/client/components/crud/customV1/List.vue";


export default {
  name: "AdminConfigListView",
  components: { CustomCrudList },
  props: {
    entityType: {
      type: String,
      default: "default",
    },

  },
  setup(props, setupContext) {
    let { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props);

    return { asyncOps, asyncOpsReady, asyncStatus };
  },

  data: function () {


    return {
      showCrudList: false,
      listConfiguration: {
        subject: "configEntry",
        listSrc: "config/list",
        showIdField: false, // bool deafult true
        sortable: false, //bool, default false
        publishable: false, //bool, default false
        enableMassActions: false,
        editRoute(item) {
          this.$router.push({
            name: "admin-config-edit-entryKey",
            params: { entryKey: item.entryKey },
          });
        },
        additionalListData: {
          simplified: false,
          translate: false,
        },
        fields: {

          entryKey: {
            itemKey: "entryKey",
            label: "admin.config.form.entryKey",
            filterable: true, // boolean, or object
            orderable: false,
          },
          entryValue: {
            itemKey: "entryValue",
            label: "admin.config.form.entryValue",
            filterable: false, // boolean, or object
            orderable: false,
          },
          description: {
            itemKey: "description",
            label: "admin.config.form.description",
            filterable: false, // boolean, or object
            orderable: false,
          },
        },
        actions: {
          show: false,
          edit: true,
          delete: false,
          create: false,
        },
      },
    };
  },

  computed: {},
  methods: {
    getEntryValueAsString(val) {
      if (val && typeof val === 'object') {
        return JSON.stringify(val);
      }

      if (Array.isArray(val)) {
        return JSON.stringify(val);
      }

      return val;
    },
    getEditRoute(id, item) {
      return {
        name: "admin-config-edit-entryKey",
        params: { entryKey: item.entryKey },
      };
    },
    getUpdateApiUrl(arg) {
      return "config/" + arg;
    },
  },
};
</script>

